import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { ChatWidget } from "@/components/ChatWidget";
import { ChatCircleDots } from "@phosphor-icons/react";

export default function Widget() {
  const { propertyId } = useParams();
  const [params] = useSearchParams();
  const embed = params.get("embed") === "1";
  const colorParam = params.get("color");
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(false);
  const resolveWidgetImg = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

  useEffect(() => {
    api.get(`/widget/${propertyId}`).then(({ data }) => setInfo(data)).catch(() => setErr(true));
  }, [propertyId]);

  useEffect(() => {
    if (embed) {
      document.documentElement.style.background = "transparent";
      document.body.style.background = "transparent";
    }
  }, [embed]);

  if (embed) {
    if (err || !info) return null;
    return (
      <ChatWidget
        embed
        propertyId={propertyId}
        brandColor={info.brand_color || colorParam || "#EA580C"}
        propertyName={info.name}
        languages={info.languages}
        survey={info.survey}
        title={info.title}
        welcomeMessage={info.welcome_message}
        avatar={resolveWidgetImg(info.avatar)}
      />
    );
  }

  if (err) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Widget not found.</div>;

  return (
    <div className="min-h-screen bg-secondary/40 grid-noise flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <div className="h-14 w-14 rounded-2xl mx-auto flex items-center justify-center text-white" style={{ background: info?.brand_color || "#EA580C" }}>
          <ChatCircleDots size={28} weight="fill" />
        </div>
        <h1 className="font-heading text-2xl font-semibold mt-5 tracking-tight">{info?.name || "Loading…"}</h1>
        <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
          This is a live preview of your embeddable AI concierge. Tap the chat bubble to ask about breakfast, parking, check-in, the spa, or to book a room — answers are grounded in your property facts.
        </p>
        <div className="mt-5 inline-flex items-center gap-2 text-xs text-muted-foreground bg-card border border-border rounded-full px-3.5 py-1.5">
          <span className="h-2 w-2 rounded-full bg-success pulse-dot" /> Powered by Guestivate · Claude
        </div>
      </div>
      {info && <ChatWidget propertyId={propertyId} brandColor={info.brand_color} propertyName={info.name} languages={info.languages} survey={info.survey} title={info.title} welcomeMessage={info.welcome_message} avatar={resolveWidgetImg(info.avatar)} />}
    </div>
  );
}
